import { getEndpoint, ENDPOINT_UNDERGRUPPER } from '../../services/service-some-api';
import { externalTooltipHandlerStacked } from './custom-tooltip';
import { returnCustomLegend, renderLegendTooltips } from './custom-legend';
import {  ChartColorsUndergrupper } from '../../consts/const-utils';
import { SalaryOrder } from '../../consts/const-salary-hierarchy';
import { EventBus, EventTypes } from '../../consts/const-event-types';
import { setGlobalChartConfig, getRootVariable, convertHEXtoRGB, setRGBTransparency } from '../../services/service-utils';
import { setChartScaleTitle, setXScaleProps, updateSalaryLegendStyle } from './chartjs-const';



export default class ChartJSStacked {
  constructor(element) {
    this.el = element
  
    // Variables and config
    this.ctx = this.el.querySelector('.chart-canvas').getContext('2d');
    this.myChart = null;

    this.legendMultiSelect = true;
    this.barThickness = 10;
    this.isStackedBars = true;
    this.salaryGroup = "Standard";


    this.savedDataPoint = {
      label: null,
      datasets: []
    }


    this.hiddenDatasets = [];
    this.dataArrays = [];

    this.chartColors = ChartColorsUndergrupper;



    // Bindings
    this.loadData = this.loadData.bind(this);
    this.setupChart = this.setupChart.bind(this);
    this.externalTooltipHandlerWrapper = this.externalTooltipHandlerWrapper.bind(this);

    
  
    // Functions
    this.init()
  }

  init()
  { 
    this.loadData();

    this.loadLegendTooltips();

    this.setupGlobalEvents();
  }


  setupGlobalEvents()
  {
    EventBus.addEventListener(EventTypes.CHART_GLOBALFILTER_UPDATE, event => 
    {
      this.setHighlightedData(event);
    });

    EventBus.addEventListener(EventTypes.CHART_DATASETS_UPDATE, event => 
    {
      this.calculateAxis();
    });

    EventBus.addEventListener(EventTypes.SALARY_LEGEND_UPDATE, event => 
    {
      const { 
        chartElement,
        salaryGroup 
      } = event.detail;


      // We update the salary legend on every chart that has the salary legend, whenever we click on it
      // This below updates the salary "selected" state on any other salary legend than the one you click on
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
      {
        updateSalaryLegendStyle(this.el, salaryGroup);
      }

      this.salaryGroup = salaryGroup;
      this.setupChart();
    });


    EventBus.addEventListener(EventTypes.CHART_LEGEND_RENDERING_DONE, event => 
    {
      const {
        chartElement
      } = event.detail;


      // Check to only update this component if requested
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
        return false;

      if(this.tooltipsData){
        renderLegendTooltips(this.el, this.tooltipsData);
      }
    });

    EventBus.addEventListener(EventTypes.CHART_LEGEND_UPDATE, event => 
    {
      const {
        chartElement
      } = event.detail;

      // Check to only update this component if requested
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
        return false;

      // Hvilke er slået fra

      const hiddenTypes = [];

      this.myChart.data.datasets.forEach((dataset, index) => 
      {
        const meta = this.myChart.getDatasetMeta(index);

        if(meta.hidden)
        {
          hiddenTypes.push(meta.label)
        }
      });


      // Update hidden status
      this.dataArraysStacked.forEach(d => 
      {
        d.types.forEach(type => 
        {
          hiddenTypes.includes(type.name) ? type.hidden = true : type.hidden = false;
        })
      })


      // Update value based on hidden status
      this.dataArraysStacked.forEach(d => 
      {
        var totalValue = 0;

        d.types.forEach((type, typeIndex) => 
        {
          
          // Find previosu type and see get its value if it is hidden and add it to the current new value
          var prevType = d.types[typeIndex - 1] ? d.types[typeIndex - 1] : null;

          if(prevType)
          {

            if(prevType.hidden == true && prevType.value != 0)
            {
              totalValue += prevType.value;
            }
            else{
              if(type.newValue) delete type['newValue'];
            }

            // If current is visible and value not null
            if(type.hidden == false && type.value != 0 && totalValue != 0)
            {
              type.newValue = type.value + totalValue;
              totalValue = 0;
            }
          }
        })
      })


      // Update  datasets with new values
      this.myChart.data.datasets.forEach(dataset => 
      {
        const newDataset = [];

        this.dataArraysStacked.forEach(d => {
          d.types.forEach(type => {
            if(type.name == dataset.label)
            {
              const value = type.newValue ? type.newValue : type.value;
              newDataset.push(value);
            }
          })
        });

        // Dont show "Offentlige chefer" if not selected
        if(this.savedDataPoint.label != null)
        {
          newDataset.splice(this.savedDataPoint.index, 1);
        }

        // Add to new dataset
        dataset.data = newDataset;
      })

      


      
      // Update axis based on new data and update
      this.calculateAxis();
      
    });

  
  }

  calculateAxis(){
    // Set same Y scale values
    this.myChart.options.scales.x.max =  this.getHighestXStackedValue();
    this.myChart.options.scales.x2.max = this.myChart.options.scales.x.max; 
    this.myChart.update();
  }



  toggleLeadersVisibility(hidePublicLeaders)
  {
    if(hidePublicLeaders)
    {
      this.myChart.data.labels.forEach((label, index) => 
      {
        if(label == "Offentlige chefer")
        {
          this.removeData(index);
        }
      });
    }
    else{
      // Show
      this.addData();
    }
  }




  addData()
  {
    // Only add if data is there
    if(this.savedDataPoint.label)
    {
      // Insert label at right place
      this.myChart.data.labels.splice(this.savedDataPoint.index,0, this.savedDataPoint.label);

      // insert datapoints at right place
      this.myChart.data.datasets.forEach((dataset, index) => {

          dataset.data.splice(this.savedDataPoint.index,0, this.savedDataPoint.datasets[index]);
      });

      this.myChart.update();

      // Reset
      this.savedDataPoint.label = null;
    }
  }



  removeData(index)
  {
    if(this.savedDataPoint.label == null)
    {
      this.savedDataPoint = {
        index: index,
        label: this.myChart.data.labels[index],
        datasets: []
      }

      this.myChart.data.labels.splice(index, 1);

      this.myChart.data.datasets.forEach((dataset) => {
    
        // Add to saved
        this.savedDataPoint.datasets.push(dataset.data[index]);

        // remove it
        dataset.data.splice(index, 1);
      
      });
      this.myChart.update();
    }
  }


  setHighlightedData(event)
  {  
    const { 
      dataComponent,
      highlightedGroups,
      hidePublicLeaders
    } = event.detail;

    // Only update if its the component requesting
    if(dataComponent === this.el.getAttribute("data-component") || dataComponent == "all")
    {
      // Remove / Add leaders depending of what is selectdd
      this.toggleLeadersVisibility(hidePublicLeaders);


      // Hightlight if anything needs to be highlisted
      var highlightedIndexArray = [];

      this.myChart.data.labels.forEach((label, index) => 
      {
        highlightedGroups.forEach(h => 
        {
          h === label ? highlightedIndexArray.push(index) : null;
        })
      });


      
      // Set colors
      this.myChart.data.datasets.forEach((dataset) => 
      {
        var colorArray = [];
  
        dataset.data.forEach((d, index) => 
        {
          if(highlightedIndexArray.includes(index) || highlightedIndexArray.length == 0)
          {
            colorArray.push(dataset.originalColor)
          }
          else{      
            var color = convertHEXtoRGB(dataset.originalColor);
            colorArray.push(setRGBTransparency(color));
          }
        })
  
        // Add color array to dataset
        dataset.backgroundColor = colorArray;
      });    
  
      // Update rendering
      this.myChart.update();
    }
  }


  setupStructuredData()
  {
    this.dataArraysStacked = [];
   
    this.data[this.salaryGroup].forEach(d => {

      const dataObj = {
        group: d.Group,
        types: []
      };   

      // Create chaining keys
      SalaryOrder.forEach(k => {

        var type = {
          name: k,
          value: parseFloat(d[k]),
          hidden: false
        };

        dataObj.types.push(type);
      })


      this.dataArraysStacked.push(dataObj);
    });

  

  }


  setupChart()
  {
    // Reset
    if(this.myChart){
      this.savedDataPoint.label = null;
      this.myChart.destroy();
    }

    if(this.ctx)
    {
      // Global config
      setGlobalChartConfig();
  
      const labels = this.data[this.salaryGroup].map(p => p.Group);

      this.dataArrays = [];


      // When all is selected
      this.data[this.salaryGroup].forEach(e => 
        {
          var dataObj = {};

          SalaryOrder.forEach(k => 
          {
            dataObj[k] = e[k] ? e[k] : "0"            
          })
      
          this.dataArrays.push(dataObj);
      });

      this.setupStructuredData();



      var dataSets = [];
      var colorIndex = 0;

      SalaryOrder.forEach(k => 
      {
        if(!this.chartColors[colorIndex]) colorIndex = 0;

        dataSets.push({
            label: k,
            data: this.dataArrays.map(p => p[k]),
            backgroundColor: [this.chartColors[colorIndex]],
            originalColor: this.chartColors[colorIndex],
            barThickness: this.barThickness,
          });
        
        colorIndex++;

      })


    
      


      // Calculate height of chart based on amount of data
      this.el.style.height = `${(labels.length * 2) * (this.barThickness * 2.05)}px`;



      this.myChart = new Chart(this.ctx, 
      {
        type: 'bar',
        data: 
        {
          labels: labels,
          datasets: dataSets
        },
        options: 
        {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          barPercentage: 1,
          layout: {
            padding: 0
        
          },
          scales:
          {
            x:{
              title: setChartScaleTitle(),
              position: "top",
              grid: {
                display: true,
                drawBorder: false,
                drawOnChartArea: true,
                drawTicks: false,
                color: getRootVariable("--color-greylight")
              },
              stacked: true,
              ticks: {
                callback: function(value)
                {
                  return `${this.getLabelForValue(value)}`;
                },
                padding: 15
              }
            },
            x2:{
              ...setXScaleProps(false)
            },
            y:{
              
              stacked: true,
              grid: {
                display: false
              },
              ticks: {
                mirror: true,
                z: 1,
                padding: 0,
                labelOffset: -(this.barThickness * 1.35),
                font: {
                  size: 13,
                  weight: "bold"
                },
              },          
            }
          },
          plugins: {
            htmlLegend: {
              containerID: 'legend-container',
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,    
              position : 'custom',        
              external: this.externalTooltipHandlerWrapper
            }
          }
        },
        plugins: [returnCustomLegend(this.el,this.legendMultiSelect)],
      });

      // Toggle Dataset visibility based on multi select or not
      if(!this.legendMultiSelect)
      {  
        const firstLegendItem = this.el.querySelector(".legend-container ul li:first-child");
        firstLegendItem ? firstLegendItem.click() : null;
      } 


      this.calculateAxis();
      


 
      // Check for Global filter
      const eventData = {
        detail: this.el.getAttribute("data-component")
      }
      const ev = new CustomEvent(EventTypes.CHART_GLOBALFILTER_REQUEST, eventData)
      EventBus.dispatchEvent(ev);

    }
  }

  getHighestXStackedValue()
  {
    var value = 0;

    this.myChart.data.labels.forEach((label, index) => 
    {
      var total = 0;

      this.myChart.data.datasets.forEach((dataset, idx) => 
      {
        var isVisible = this.myChart.isDatasetVisible(idx);

        if(isVisible)
        {
          total += parseFloat(dataset.data[index])
        }
      });

      if(total > value)
      {
        value = total;
      }
    });

    // Buffer on top
    value = Math.ceil(value / 100) * 100;

    return value;
  }


  externalTooltipHandlerWrapper(context)
  {
    externalTooltipHandlerStacked(context, this.myChart, this.dataArrays, "ansat som");
  }



  async loadData()
  {
    this.data = await getEndpoint(ENDPOINT_UNDERGRUPPER);

    if(this.data)
    {
      this.setupChart();
    }
  }

  async loadLegendTooltips(url)
  {
    const tooltipsSrc = this.el.querySelector("[data-src-tooltips]");
    if(tooltipsSrc)
    {
      const url = tooltipsSrc.getAttribute("data-src-tooltips");
      if(url)
      {
        this.tooltipsData = await getEndpoint(`/assets/data/tooltips/${url}`);

        if(this.tooltipsData)
        {
          renderLegendTooltips(this.el, this.tooltipsData);
        }
      }
    }
  }


}
